/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { RouteConfig } from 'vue-router';

const StaffHome = () =>
  import(
    /* webpackChunkName: "StaffHome" */
    '@/views/Staff/Home.vue'
  );

const transactionHistoryRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: 'staff',
      name: 'SaffHome',
      component: StaffHome,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default transactionHistoryRoute;
